import { NgModule } from "@angular/core";
import { EdpWidgetAdvantagesAndBenefitsComponent } from "@edp-components/edp-card-widgets/edp-widget-advantages-and-benefits/edp-widget-advantages-and-benefits.component";
import { EdpWidgetBannerModule } from "@edp-components/edp-card-widgets/edp-widget-banner/edp-widget-banner.module";
import { EdpWidgetBillingComponent } from "@edp-components/edp-card-widgets/edp-widget-billing/edp-widget-billing.component";
import { EdpWidgetChartBillingComponent } from "@edp-components/edp-card-widgets/edp-widget-chart-billing/edp-widget-chart-billing.component";
import { EdpContractConsumptionsComponent } from "@edp-components/edp-card-widgets/edp-widget-consumptions";
import { EdpWidgetContaCertaComponent } from "@edp-components/edp-card-widgets/edp-widget-conta-certa/edp-widget-conta-certa.component";
import { EdpWidgetFuncionaComponent } from "@edp-components/edp-card-widgets/edp-widget-funciona/edp-widget-funciona.component";
import { EdpWidgetHealthComponent } from "@edp-components/edp-card-widgets/edp-widget-health/edp-widget-health.component";
import { EdpWidgetMobilityComponent } from "@edp-components/edp-card-widgets/edp-widget-mobility/edp-widget-mobility.component";
import { EdpWidgetPartnersComponent } from "@edp-components/edp-card-widgets/edp-widget-partners/edp-widget-partners.component";
import { EdpWidgetRequestsComponent } from "@edp-components/edp-card-widgets/edp-widget-requests/edp-widget-requests.component";
import { EdpWidgetPaymentDebtComponent } from "@edp-components/edp-card-widgets/edp-widget-payment-debt/edp-widget-payment-debt.component";
import { EdpWidgetSavingsComponent } from "@edp-components/edp-card-widgets/edp-widget-savings/edp-widget-savings.component";
import { EdpWidgetSmartNowComponent } from "@edp-components/edp-card-widgets/edp-widget-smart-now/edp-widget-smart-now.component";
import { EdpWidgetWithoutBillingComponent } from "@edp-components/edp-card-widgets/edp-widget-without-billing/edp-widget-without-billing.component";
import { EdpSmartnowDashboardWidgetComponent } from "@edp-components/edp-smartnow-dashboard-widget/edp-smartnow-dashboard-widget.component";
import { EdpSmartnowNextBillingWidgetComponent } from "@edp-components/edp-smartnow-next-billing-widget/edp-smartnow-next-billing-widget.component";
import { SharedModule } from "@edp-components/shared.module";
import { EdpDashboardGridComponent } from "./edp-dashboard-grid.component";
import { EdpWidgetOnboardingWhatsNewModule } from "@edp-components/edp-card-widgets/edp-widget-onboarding-whats-new/edp-widget-onboarding-whats-new.module";
import { EdpWidgetConsumptionOmieModule } from "@edp-components/edp-card-widgets/edp-widget-consumption-omie/edp-widget-consumption-omie.module";
@NgModule({
    declarations: [EdpDashboardGridComponent],
    imports: [SharedModule, EdpWidgetBannerModule, EdpWidgetConsumptionOmieModule],
    entryComponents: [
        EdpDashboardGridComponent,
        // Dynamic loaded Widgets List
        EdpWidgetPaymentDebtComponent,
        EdpWidgetBillingComponent,
        EdpWidgetChartBillingComponent,
        EdpContractConsumptionsComponent,
        EdpWidgetHealthComponent,
        EdpWidgetPartnersComponent,
        EdpWidgetAdvantagesAndBenefitsComponent,
        EdpWidgetSavingsComponent,
        EdpWidgetRequestsComponent,
        EdpWidgetFuncionaComponent,
        EdpWidgetContaCertaComponent,
        EdpWidgetWithoutBillingComponent,
        EdpWidgetSmartNowComponent,
        EdpSmartnowDashboardWidgetComponent,
        EdpSmartnowNextBillingWidgetComponent,
        EdpWidgetMobilityComponent,
        EdpWidgetOnboardingWhatsNewModule
    ],
    exports: [EdpDashboardGridComponent],
})
export class EdpDashboardGridModule {}
